import { render, staticRenderFns } from "./AppNewsModal.vue?vue&type=template&id=7ced4ea3&scoped=true&"
import script from "./AppNewsModal.vue?vue&type=script&lang=js&"
export * from "./AppNewsModal.vue?vue&type=script&lang=js&"
import style0 from "./AppNewsModal.vue?vue&type=style&index=0&id=7ced4ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ced4ea3",
  null
  
)

export default component.exports